import React from 'react';
import { motion } from 'framer-motion';

// Import components
import {
  Header,
  Hero,
  Features,
  Pricing,
  Contact,
  Footer
} from './components';
import ScrollArrow from '../../components/ui/ScrollArrow';


const LandingPage: React.FC = () => {
  // Fonction pour scroller vers la prochaine section
  const scrollToNextSection = () => {
    const sections = ['hero', 'features', 'pricing', 'contact'];
    const currentScrollY = window.pageYOffset;
    
    // Trouver la prochaine section
    for (const sectionId of sections) {
      const element = document.getElementById(sectionId);
      if (element) {
        const elementTop = element.offsetTop;
        if (elementTop > currentScrollY + 100) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
      }
    }
    
    // Si aucune section trouvée, scroll par défaut
    window.scrollBy({
      top: window.innerHeight * 0.8,
      behavior: 'smooth'
    });
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <Header />
      
      {/* Hero Section */}
      <div id="hero">
        <Hero />
      </div>
      
      {/* Features Section */}
      <div id="features">
        <Features />
      </div>
      
      {/* Pricing Section */}
      <div id="pricing">
        <Pricing />
      </div>
      
      {/* Contact Section */}
      <div id="contact">
        <Contact />
      </div>
      

      {/* Footer */}
      <Footer />
      
      {/* Dynamic Scroll Arrow */}
      <ScrollArrow 
        delay={2000}
        bottomOffset={80}
        onScrollDown={scrollToNextSection}
      />
    </div>
  );
};

export default LandingPage;